import { render, staticRenderFns } from "./Enable2FA.vue?vue&type=template&id=57f53fb8&scoped=true"
import script from "./Enable2FA.vue?vue&type=script&lang=js"
export * from "./Enable2FA.vue?vue&type=script&lang=js"
import style1 from "./Enable2FA.vue?vue&type=style&index=1&id=57f53fb8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f53fb8",
  null
  
)

export default component.exports